import { EntraIdIconUrl } from "@p0security/shared/integrations/constants";
import { EntraIdComponents } from "@p0security/shared/integrations/directories/azure-ad/components";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useCallback } from "react";

import { Install, InstallProps } from "../Install/Install";
import { LegacyAzureAd } from "./LegacyAzureAd";
import { entraIdInstaller } from "./install";

export const EntraId = (
  props: Pick<
    InstallProps<typeof EntraIdComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const flags = useFlags();
  const itemKind = useCallback(() => "tenant", []);

  // Use feature flag to switch between legacy OAuth and new install framework
  const { entraInstallV2 } = flags;

  if (!entraInstallV2) {
    return <LegacyAzureAd />;
  }

  return (
    <Install<typeof EntraIdComponents>
      components={EntraIdComponents}
      installer={entraIdInstaller}
      integration="azure-ad"
      itemKind={itemKind}
      logo={EntraIdIconUrl}
      title={"Entra ID (Legacy)"}
      {...props}
    />
  );
};
